import { InjectionToken } from '@angular/core';

/**
 * Base URL for the backend's Express `onRequest` surface — the value each app keeps in
 * `environment.backendApiUrl`. Provided by the app so the shared `BackendApiService` never
 * has to import an app-local `environment`.
 */
export const BACKEND_API_URL = new InjectionToken<string>('BACKEND_API_URL');
